import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href: string;
  className?: string;
}
export function CTAButton({
  children,
  href,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`inline-block bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold text-xl md:text-2xl px-8 md:px-12 py-5 md:py-6 rounded-lg shadow-2xl transform hover:scale-105 transition-all duration-200 text-center ${className}`} data-id="element-332">
      {children}
    </a>;
}